if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHelloTabs)
} else {
  initializeHelloTabs()
}

function initializeHelloTabs() {
  document.querySelectorAll('.hello-tabs').forEach(initializeTabSection)
  document.querySelectorAll('.hello-tabs__html[data-html-url]').forEach(loadHtmlTab)
}

// Same approach as sections/marketing-landing-page.liquid: fetch the file and
// render it via iframe srcdoc so its CSS is isolated from the theme.
function loadHtmlTab(containerEl) {
  const url = containerEl.dataset.htmlUrl
  if (!url || containerEl.dataset.htmlLoaded) return
  containerEl.dataset.htmlLoaded = 'true'

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error('Failed to load HTML file: ' + response.status)
      return response.text()
    })
    .then((html) => {
      const iframe = document.createElement('iframe')
      iframe.className = 'hello-tabs__html-iframe'
      iframe.srcdoc = html
      containerEl.innerHTML = ''
      containerEl.appendChild(iframe)

      iframe.onload = () => {
        try {
          const doc = iframe.contentDocument || iframe.contentWindow.document
          const updateHeight = () => {
            // Hidden tab panel (display: none) can't be measured
            if (!iframe.offsetParent) return
            // scrollHeight is never smaller than the iframe viewport, so collapse
            // first to measure the real content height (lets it shrink again)
            iframe.style.height = '0px'
            const height = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight)
            iframe.style.height = height > 0 ? height + 'px' : ''
          }
          updateHeight()
          // Tab panels load while display: none — re-measure on show/resize
          if (window.ResizeObserver) {
            new ResizeObserver(updateHeight).observe(containerEl)
            new iframe.contentWindow.ResizeObserver(updateHeight).observe(doc.body)
          }
        } catch (e) {
          iframe.style.minHeight = '500px'
        }
      }
    })
    .catch((error) => {
      console.error('Error loading tab HTML file:', error)
      containerEl.innerHTML = ''
    })
}

function initializeTabSection(tabSectionEl) {
  const triggerEls = tabSectionEl.querySelectorAll('.hello-tabs__tab-trigger')
  const contentEls = tabSectionEl.querySelectorAll('.hello-tabs__hello-card')
  const navContentEl = tabSectionEl.querySelector('.hello-tabs__navigation-content')
  const prevBtnEl = tabSectionEl.querySelector('.hello-tabs__prev-btn')
  const nextBtnEl = tabSectionEl.querySelector('.hello-tabs__next-btn')
  let activeIndex = 0

  triggerEls[0].classList.add('hello-tabs__tab-trigger--active')
  contentEls[0].classList.add('hello-tabs__hello-card--active')

  navContentEl.addEventListener('click', (event) => {
    const trigger = event.target.closest('.hello-tabs__tab-trigger')
    if (!trigger) return
    const clickedIndex = +trigger.dataset.tabIndex
    if (clickedIndex !== activeIndex) {
      setActiveTab(clickedIndex)
    }
  })

  prevBtnEl.addEventListener('click', () => {
    if (activeIndex > 0) {
      setActiveTab(activeIndex - 1)
    } else {
      scrollToActiveTab()
    }
  })

  nextBtnEl.addEventListener('click', () => {
    if (activeIndex < triggerEls.length - 1) {
      setActiveTab(activeIndex + 1)
    } else {
      scrollToActiveTab()
    }
  })

  navContentEl.addEventListener('scroll', updateNavButtons, { passive: true })
  window.addEventListener('resize', debounce(updateNavButtons, 150))
  updateNavButtons()

  function setActiveTab(newIndex) {
    triggerEls[activeIndex].classList.remove('hello-tabs__tab-trigger--active')
    contentEls[activeIndex].classList.remove('hello-tabs__hello-card--active')
    triggerEls[newIndex].classList.add('hello-tabs__tab-trigger--active')
    contentEls[newIndex].classList.add('hello-tabs__hello-card--active')
    activeIndex = newIndex
    scrollToActiveTab()
  }

  function scrollToActiveTab () {
    let scrollTarget
    if (activeIndex === 0) {
      scrollTarget = 0
    } else if (activeIndex === triggerEls.length - 1) {
      scrollTarget = navContentEl.scrollWidth - navContentEl.clientWidth
    } else {
      const tab = triggerEls[activeIndex]
      scrollTarget = tab.offsetLeft - (navContentEl.clientWidth / 2) + (tab.clientWidth / 2)
    }

    navContentEl.scrollTo({
      left: scrollTarget,
      behavior: 'smooth'
    })
  }

  function updateNavButtons() {
    const scrollLeft = navContentEl.scrollLeft
    const maxScroll = navContentEl.scrollWidth - navContentEl.clientWidth

    if (maxScroll <= 1) {
      prevBtnEl.style.display = 'none'
      nextBtnEl.style.display = 'none'
      return
    }

    prevBtnEl.style.display = scrollLeft > 1 ? 'flex' : 'none'
    nextBtnEl.style.display = scrollLeft < maxScroll - 1 ? 'flex' : 'none'
  }
}

function debounce(fn, delay) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}
